import React, { useState, useContext } from "react";
import { LoginContainer } from "./styles";
import { useLocation } from "wouter";

import { AuthContext } from "contexts/AuthContext";
import useAuth from "hooks/useAuth";

import LoginForm from "components/LoginForm";

import LoginIcon from "icons/LoginIcon";
import LoginoutIcon from "icons/LoginoutIcon";

import { colors } from "definitions";

export default function Login({ overlay }) {
  const [showLogin, setShowLogin] = useState(false);

  const { userLogged } = useContext(AuthContext);
  const { signOut } = useAuth();
  const [, navigate] = useLocation();

  const HandleLogin = () => {
    setShowLogin(true);
  };

  const HandleLogout = () => {
    signOut()
      .then(() => {
        navigate("/");
      })
      .catch((error) => {
        console.log(error.message);
      });
  };

  const HandleCloseForm = () => {
    setShowLogin(false);
  };

  const iconColor = overlay ? colors.icons.white : colors.icons.gray;

  /* El cierre vive adentro del modal (X, Esc o click afuera): mientras está
     abierto el header queda `inert`, así que acá no hay nada que alternar. */
  return (
    <LoginContainer>
      {!userLogged ? (
        <LoginIcon onClick={HandleLogin} color={iconColor} />
      ) : (
        <LoginoutIcon onClick={HandleLogout} color={iconColor} />
      )}
      <LoginForm onClose={HandleCloseForm} open={showLogin} />
    </LoginContainer>
  );
}
